export enum communityReportReason {
  INSULT = 'Insult',
  NAKED = 'Naked',
  SPOILER = 'Spoiler',
  ETC = 'Etc'
}
